import React, { Component } from "react";
import { connect } from "react-redux";
import { Form } from "antd";
import { getAuditLogs } from "./actions";
import Page from "./Page";
import { getEvent } from "../../utils/token";

class AuditLogCard extends Component {
  render() {
    return <Page {...this.props} />;
  }
}

const AuditLogForm = Form.create({ name: "audit-log-form" })(AuditLogCard);

function mapStateToProps(state) {
  return {
    isLoading: state.auditLog.isLoading,
    auditLogData: state.auditLog.auditLogData,
    auditLogsData: state.auditLog.auditLogsData,
    event: getEvent()
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onGetAuditLogs: (data) => dispatch(getAuditLogs(data)),
    // onCreateAuditLog: (data) => dispatch(createAuditLog(data)),
    // onUpdateAuditLog: (data) => dispatch(updateAuditLog(data)),
    // onDeleteAuditLog: (data) => dispatch(deleteAuditLog(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuditLogForm);
